<template>
  <private-gym-page id="payment-single-success-page" name="payment-success" :has_fab="true">

    <f7-block-title medium>
      Betalingen Gelukt
    </f7-block-title>

  </private-gym-page>
</template>

<script>

import PrivateGymPage from "../../../pages/_layouts/PrivateGymPage.vue";

import moment from 'moment/dist/moment';
import 'moment/dist/locale/nl';
moment.locale('nl');

export default {
  components: {PrivateGymPage},

  props: {
    f7route: Object,
    f7router: Object,
  },

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    current_user() {
      return this.$store.state.current_user.data;
    },
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },

  watch: {
    //
  }
};
</script>
